<template>
  <div class="flex flex-col items-center justify-center min-h-[60vh]">
    <div class="bg-white shadow-lg rounded-lg p-8 w-full max-w-md flex flex-col gap-6">
      <h2 class="text-2xl font-bold text-center mb-4">Mon compte</h2>
      <div class="flex flex-col gap-2">
        <label class="font-semibold">Adresse e-mail</label>
        <div class="flex gap-2 flex-col">
          <input
            v-model="email"
            type="email"
            class="basicInput"
            :disabled="!editEmail"
          />
          <div class="flex gap-1">
            <button v-if="!editEmail" class="callToAction" @click="editEmail = true">Modifier</button>
            <button v-else class="callToAction" @click="updateEmail">Enregistrer</button>
            <button v-if="editEmail" class="bg-gray-200 px-3 py-2 rounded hover:bg-gray-300 flex items-center justify-center" @click="cancelEdit">Annuler</button>
          </div>
        </div>
        <span v-if="emailError" class="text-red-500 text-sm">{{ emailError }}</span>
        <span v-if="emailSuccess" class="text-green-600 text-sm">{{ emailSuccess }}</span>
      </div>
      <button class="flex items-center justify-center" @click="logout">
        Se déconnecter
      </button>
      <button
        class="flex items-center justify-center !bg-red-500 !text-white px-4 py-2 rounded hover:!bg-red-600"
        @click="confirmDelete = true"
        v-if="!isSubUser"
      >
        Supprimer le compte
      </button>
    </div>
    <!-- Confirmation suppression -->
    <div v-if="confirmDelete" class="fixed inset-0 bg-black bg-opacity-10 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-lg shadow-lg flex flex-col gap-4">
        <p class="text-lg">Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.</p>
        <div class="flex gap-4 justify-end">
          <button class="callToAction" @click="confirmDelete = false">Annuler</button>
          <button class="bg-red-500 text-white px-4 py-2 rounded" @click="deleteAccount">Supprimer</button>
        </div>
        <span v-if="deleteError" class="text-red-500 text-sm">{{ deleteError }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { db, auth } from '@/firebase'
import { verifyBeforeUpdateEmail, signOut } from 'firebase/auth'
import { doc, updateDoc, getDoc } from 'firebase/firestore'
import { deleteUserAndData } from '@/services/userService';

export default {
  data() {
    return {
      email: '',
      editEmail: false,
      emailError: '',
      emailSuccess: '',
      confirmDelete: false,
      deleteError: '',
      isSubUser: null, // Ajouté
    }
  },
  async mounted() {
    if (auth.currentUser) {
      this.email = auth.currentUser.email
      // Vérifie si c'est un sous-user
      const userDoc = await getDoc(doc(db, "users", auth.currentUser.uid));
      if (userDoc.exists() && userDoc.data().mainUserId) {
        this.isSubUser = true;
      }
    }
  },
  methods: {
    cancelEdit() {
      this.editEmail = false
      this.emailError = ''
      this.emailSuccess = ''
      this.email = auth.currentUser?.email || ''
    },
    async updateEmail() {
      this.emailError = ''
      this.emailSuccess = ''
      const currentEmail = auth.currentUser?.email || ''
      if (!this.email || !this.email.includes('@')) {
        this.emailError = "Adresse e-mail invalide."
        return
      }
      if (this.email === currentEmail) {
        this.editEmail = false
        return // Pas de changement, on ne fait rien
      }
      try {
        await verifyBeforeUpdateEmail(auth.currentUser, this.email)
        // Ajoute cette partie pour mettre à jour Firestore :
        const userDocRef = doc(db, "users", auth.currentUser.uid);
        await updateDoc(userDocRef, { email: this.email });
        this.emailSuccess = "Un email de vérification a été envoyé à la nouvelle adresse. Veuillez la valider pour finaliser le changement."
        this.editEmail = false
      } catch (e) {
        if (e.code === 'auth/requires-recent-login') {
          this.emailError = "Veuillez vous reconnecter pour modifier votre e-mail."
        } else if (e.code === 'auth/email-already-in-use') {
          this.emailError = "Cette adresse e-mail est déjà utilisée."
        } else if (e.code === 'auth/invalid-email') {
          this.emailError = "Format d'adresse e-mail invalide."
        } else if (e.code === 'auth/operation-not-allowed') {
          this.emailError = "La modification d'email n'est pas autorisée. Contactez l'administrateur."
        } else {
          this.emailError = e.message || "Erreur lors de la mise à jour."
        }
      }
    },
    async deleteAccount() {
      this.deleteError = ''
      if (this.isSubUser) {
        this.deleteError = "Un sous-utilisateur ne peut pas supprimer son compte. Contactez l'administrateur principal.";
        return;
      }
      try {
        await deleteUserAndData();
        this.confirmDelete = false
        this.$router.push('/') // Redirige après suppression
      } catch (e) {
        if (e.code === 'auth/requires-recent-login') {
          this.deleteError = "Veuillez vous reconnecter pour supprimer votre compte."
        } else if (e.details) {
          this.deleteError = `Erreur lors de la suppression : ${e.details}`;
        } else if (e.message) {
          this.deleteError = `Erreur lors de la suppression : ${e.message}`;
        } else {
          this.deleteError = "Erreur lors de la suppression du compte et des données."
        }
        // Optionnel : log dans la console pour debug
        console.error(e);
      }
    },
    async logout() {
      await signOut(auth)
      this.$router.push('/')
    }
  }
}
</script>